import { render, staticRenderFns } from "./BaseRangeSlider.vue?vue&type=template&id=61b6a162&scoped=true&"
import script from "./BaseRangeSlider.vue?vue&type=script&lang=js&"
export * from "./BaseRangeSlider.vue?vue&type=script&lang=js&"
import style0 from "./BaseRangeSlider.vue?vue&type=style&index=0&id=61b6a162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b6a162",
  null
  
)

export default component.exports